import { Select } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { getSteps } from "../../../api/courses.api";
import useAxios from "../../../hooks/useAxios";
import { IGetSteps } from "../../../models/courses.model";
import useLoader from "../../../hooks/useLoader";

interface IProps {
  courseCode: string|undefined;
  setCourseCode: (value: string) => void;
  includeAll?: boolean;
  eduStepCode?: string;
  placeholder?: string;
}

const SelectLevel: FC<IProps> = ({
  courseCode,
  setCourseCode,
  includeAll = false,
  eduStepCode,
  placeholder,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSteps>();
  useLoader(isLoading, [error]);

  const [steps, setSteps] = useState<any>();

  useEffect(() => {
    execute(getSteps());
  }, []);

  useEffect(() => {
    if (res) {
      const _steps: any = [];
      res.data?.forEach(item => {
        item.step?.forEach(subitem => {
          _steps.push({
            ...subitem,
            eduStepCode: item.eduStepCode,
          });
        });
      });
      setSteps(_steps);
    }
  }, [res]);

  const getStepOptions = () => {
    const data = eduStepCode
      ? steps?.filter((item: any) => item.eduStepCode === eduStepCode)
      : steps;
    return data?.map((item: any) => (
      <Select.Option
        key={item.courseCode}
        value={item.courseCode}
      >
        {item.courseName}
      </Select.Option>
    ));
  };

  return (
    <Select
      placeholder={placeholder || t('statistics.dttt.column1')}
      value={courseCode}
      onChange={value => setCourseCode(value)}
    >
      {includeAll && (
        <Select.Option value="">
          {t('common.text.all')}
        </Select.Option>
      )}
      {getStepOptions()}
    </Select>
  );
}

export default SelectLevel;